(function () {

    var formApp = angular.module("formApp");

    formApp.controller('layoutController',
        [
            '$scope', '$timeout', '$interval', 'DataServices', 'UtilityServices', '$rootScope', 'Constants',
            function ($scope, $timeout, $interval, DataServices, UtilityServices, $rootScope, Constants) {
                $scope.utility = UtilityServices;

                $rootScope.$on("adal:acquireTokenFailure",
                    function () {
                        $scope.utility.handleSessionTimeOut();
                    });

                $scope.openFmsAdminSite = function () {
                    DataServices.navigateToAdminFmsSite();
                }

                $scope.navs = {
                    manageFeedbacks: Constants.Url.manageFeedbacks,
                    manageComplaints: Constants.Url.manageComplaints,
                    tools: Constants.Url.tools
                };               

                $scope.exitFms = function () {
                    window.location.replace('https://google.com.au');
                };
                $timeout(function () {
                    $scope.utility.setMenuVisibility();
                    $scope.userFullName = DataServices.userFullName();
                    $scope.salutation = $scope.userFullName ? ('Hello, ' + $scope.userFullName + '!') : '';
                    $scope.showExitButton = $scope.salutation=='';
                }, 0);
            }]);
}());

